import { render, staticRenderFns } from "./turn-source-button.vue?vue&type=template&id=4cfda090"
import script from "./turn-source-button.vue?vue&type=script&lang=ts"
export * from "./turn-source-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports